import { memo } from 'react'
import { Icon } from '@winnin/ds-icon'
import { Modal } from '@winnin/ds-modal'

import { withTolgee } from 'lib/tolgee'

import { translations } from './modal-documents-tips.i18n'
import type { IModalDocumentsTipsProps } from './modal-documents-tips.types'

import '@winnin/ds-modal/styles.css'
import './modal-documents-tips.styles.scss'

const Component = withTolgee<IModalDocumentsTipsProps>(
  ({ isOpen = false, shouldAnimate = false, handleOnClose, handleOnUpload, t }) => (
    <Modal show={isOpen} animate={shouldAnimate} backgroundColor="#000000" classes={['ModalDocumentsTips']}>
      <Modal.Overlay onClick={handleOnClose} color="rgba(0, 0, 0, 0.8)" />
      <Modal.Header onClose={handleOnClose} classes={['ModalDocumentsTips-header']}>
        <h2 className="ModalDocumentsTips-header-title">{t(translations.headerTitle)}</h2>
      </Modal.Header>
      <Modal.Body classes={['ModalDocumentsTips-body']}>
        <ul className="ModalDocumentsTips-body-card-list">
          <li className="ModalDocumentsTips-body-card-list-item">
            <Icon name="brain" width={46} height={46} color="var(--color_primary_300)" />
            <h3 className="ModalDocumentsTips-body-card-list-item-title">{t(translations.bodyFirstCardTitle)}</h3>
            <p className="ModalDocumentsTips-body-card-list-item-body">{t(translations.bodyFirstCardBody)}</p>
          </li>
          <li className="ModalDocumentsTips-body-card-list-item">
            <Icon name="copy" width={46} height={46} color="var(--color_primary_300)" />
            <h3 className="ModalDocumentsTips-body-card-list-item-title">{t(translations.bodySecondCardTitle)}</h3>
            <p className="ModalDocumentsTips-body-card-list-item-body">{t(translations.bodySecondCardBody)}</p>
          </li>
          <li className="ModalDocumentsTips-body-card-list-item">
            <Icon name="padlock" width={46} height={46} color="var(--color_primary_300)" />
            <h3 className="ModalDocumentsTips-body-card-list-item-title">{t(translations.bodyThirdCardTitle)}</h3>
            <p className="ModalDocumentsTips-body-card-list-item-body">{t(translations.bodyThirdCardBody)}</p>
          </li>
        </ul>
      </Modal.Body>
      <Modal.Footer classes={['ModalDocumentsTips-footer']}>
        <div className="ModalDocumentsTips-footer-box">
          <p className="ModalDocumentsTips-footer-box-title">{t(translations.footerTitle)}</p>
          <button type="button" onClick={handleOnUpload} className="ModalDocumentsTips-footer-box-action">
            <Icon name="upload" width={20} height={20} />
            {t(translations.footerAction)}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
)

export const ModalDocumentsTipsView = memo(Component)
